import type { Vrf } from '../fetchVrf';

export const isVrfAutodetect = (vrf: Vrf): vrf is null => vrf === null;
